import { isString } from 'util';

export class User {
    userID: number ;
    firstName: string ;
    secondName: string ;
    firstLastName: string ;
    secondLastName: string ;
    wicID: string ;
    user:string;
    birthdate: string ;
    password: string ;
    token?: string;
    roleID:String;
    tipo:String;
    IsReadyToContract:String;
    corporation:String;
    Sellos: any;
    Correo: any;
    constructor(user) {
        this.userID = (user.id ?  user.userID : undefined);
        this.firstName = (user.firstName ?  user.firstName : '');
        this.secondName = (user.secondName ?  user.secondName : '');
        this.firstLastName = (user.firstLastName ?  user.firstLastName : '');
        this.secondLastName = (user.secondLastName ?  user.secondLastName : '');
        this.wicID = (user.wicID ?  user.wicID : undefined);
        this.user = (user.user ? user.user : undefined);
        this.birthdate = (user.birthdate ?  (isString(user.birthdate) ? user.birthdate : (user.birthdate.day + '-' + user.birthdate.month + '-' + user.birthdate.year)) : '');
        this.password = (user.password ?  user.password : '');
        this.token = (user.token ?  user.token : '');
        this.roleID = (user.roleID ? user.roleID : '')
        this.Correo= user.Correo??"";
    }
}
